import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { getComments } from "../redux/slices/product/thunk";

const CommentsDialog = ({ open, onClose, productId, dispatch }) => {
  const { t } = useTranslation();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && productId) {
      const fetchComments = async () => {
        try {
          setLoading(true);
          const result = await dispatch(getComments({id:productId}));
          setComments(result.payload || []);
        } catch (err) {
          setError(t("comments.fetchError"));
        } finally {
          setLoading(false);
        }
      };
      fetchComments();
    }
  }, [open, productId, dispatch, t]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{t("comments.title")}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : comments.length === 0 ? (
          <Typography>{t("comments.noComments")}</Typography>
        ) : (
         comments.map((comment) => (
  <Box key={comment._id} mb={3} display="flex" gap={2} alignItems="flex-start">
    {/* Avatar */}
   <Box>
  {comment.user?.image ? (
    <img
      src={comment.user.image}
      alt={comment.user?.userName || "User"}
      style={{
        width: 50,
        height: 50,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  ) : (
    <Avatar
      sx={{ width: 50, height: 50, fontSize: 20 }}
    >
      {comment.user?.userName?.charAt(0)?.toUpperCase() || "U"}
    </Avatar>
  )}
</Box>

    {/* Comment content */}
    <Box flex={1}>
      <Typography variant="subtitle2" fontWeight="bold">
        {comment.user?.userName || t("comments.unknownUser")}
      </Typography>

      <Typography variant="caption" color="textSecondary" display="block" mb={0.5}>
        {new Date(comment.createdAt).toLocaleString()}
      </Typography>

      <Typography variant="body1">{comment.comment}</Typography>
      <Divider sx={{ mt: 2 }} />
    </Box>
  </Box>
))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};
export default CommentsDialog;
